import { FileFromType } from "../enum";

export const fileFromTypes: Record<FileFromType, string> = {
  INVALID: "Invalid",
  FROM_DOCTOR: "Doctor",
  FROM_LAB: "Labstaff",
};
